/* eslint-disable import/order */
/* eslint-disable camelcase */
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Container,
  Typography,
  Box,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDateTime } from 'utils/formatTime';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { DataGrid } from '@mui/x-data-grid';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';
import CustomGridToolbar from 'components/CustomGridToolbar';
// ----------------------------------------------------------------------



export default function ActivityLog() {
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [sort, setSort] = useState({field:'id', order:'desc',start_date:'',end_date:'',user_type:'user'});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const [query,setQuery] = useState({page_size:100,page:0});
  const [profileDialog,setProfileDialog] = useState({open:false,user:"",});


  useEffect(() => {
    getInitData();
  }, []);

  return (
    <Page title="Activity log">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Activity log"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'All user activities' },
          ]}
        />

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"end", width:"100%", padding:2}}>
             <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.start_date}
                  label="From date"
                  onChange={(newValue) => setSort({...sort,start_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.end_date}
                  label="To date"
                  onChange={(newValue) => setSort({...sort,end_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{width:180,ml:2}}>
              <InputLabel id="demo-simple-select-label">User type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="user_type"
                value={sort.user_type}
                onChange={(e)=> setSort({...sort,user_type:e.target.value})}
                >
                {[
                  {v:'user',n:"Users"},
                  {v:'staff',n:"Staffs"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <InputLabel id="demo-simple-select-label2">Created at</InputLabel>
              <Select
                labelId="demo-simple-select-label2"
                label="Created at"
                value={sort.order}
                onChange={(e)=> setSort({...sort,order:e.target.value})}
              >
                {[
                  {v:'asc',n:"Ascending"},
                  {v:'desc',n:"Descending"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton loading={state.loading} onClick={()=> getInitData()}
              sx={{ml:2}} variant='outlined' color="secondary">
                Apply changes
            </LoadingButton> 
            
          </Box>

          <Box sx={{ height: 700, width: '100%' }}>
            <DataGrid
              rows={data.data}
              columns={[
                {
                  field: 'name',
                  headerName: 'Name',
                  width: 220,
                  editable: false,
                  renderCell: (params) => (
                    < >
                      {params.row.user_type ==="user" && (
                        <IconButton color="primary" onClick={()=> setProfileDialog({open:true,user:params.row})}>
                          <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                        </IconButton>
                      )}
                      <Typography variant="subtitle2" sx={{cursor:"pointer"}} noWrap>
                        {params.row.user_type ==="user" 
                          ? `${params.row.first_name} ${params.row.last_name}`
                          : params.row.staff_name }
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => params.row.user_type ==="user" 
                    ? `${params.row.first_name} ${params.row.last_name}` 
                    : params.row.staff_name
                },
                {
                  field: 'action',
                  headerName: 'action',
                  width: 200,
                  editable: false,
                },
                {
                  field: 'msg',
                  headerName: 'Message',
                  width: 400,
                  editable: false,
                },
                {
                  field: 'created_at',
                  headerName: 'Created at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDateTime(params.value),
                },
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

              // pagination 
              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setQuery({...query, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setQuery({...query, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>

        </Card>
      </Container>


      {profileDialog.open &&  <ProfileDialog
        user={profileDialog.user}
        handleClose={()=>{
          setProfileDialog({open:false});
        }}
        refresh
         />}

    </Page>
  );

  async function getInitData(page = null) {
    
    const sdate = sort.start_date ?  new Date(sort.start_date).toDateString() : '';
    const edate = sort.end_date ?  new Date(sort.end_date).toDateString() : '';

    setState({...state,loading:true,loadComplete:false,error:null});

    try {

      let str = `?&sort_order=${sort.order}&user_type=${sort.user_type}`;
        str+= `&page=${page || query.page}&&page_size=${query.page_size}`;
        str+= `&start_date=${sdate}&end_date=${edate}`;

      const response = await axios.get(CRUD.activities+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };

}
